/** Numbers, sizes and dates as people read them, in the page's language. */
import i18n from "@/i18n";

function locale(): string {
  return i18n.language === "en" ? "en-IN" : i18n.language;
}

export function formatNumber(value: number, digits = 2): string {
  return new Intl.NumberFormat(locale(), { maximumFractionDigits: digits }).format(value);
}

export function formatBytes(bytes: number): string {
  if (bytes >= 1024 * 1024) {
    return `${formatNumber(bytes / (1024 * 1024), 1)} MB`;
  }
  return `${formatNumber(Math.max(bytes / 1024, 0.1), 1)} KB`;
}

export function formatDateTime(iso: string): string {
  return new Intl.DateTimeFormat(locale(), { dateStyle: "medium", timeStyle: "short" }).format(
    new Date(iso),
  );
}

export function formatDate(iso: string): string {
  return new Intl.DateTimeFormat(locale(), { dateStyle: "medium" }).format(new Date(iso));
}
